"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _en = _interopRequireDefault(require("../locales/en.json"));
var _es = _interopRequireDefault(require("../locales/es.json"));
var _utils = require("../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useTranslation = languageProp => {
  const t = path => {
    const obj = {
      en: _en.default,
      es: _es.default
    };
    const lang = languageProp || process.env.REACT_APP_LANG || 'en';
    return (0, _utils.get)(obj[lang], path, '');
  };
  return {
    t
  };
};
var _default = exports.default = useTranslation;